import { AnalyticsUtils } from 'utils'
import { FeedbackForm } from 'common-frontend'

import './supportForm.scss'

export default class SupportForm extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object,
  }

  static propTypes = {
    href: React.PropTypes.string.isRequired,
    featureType: React.PropTypes.string.isRequired,
    featureKey: React.PropTypes.string,
  }

  state = {
    showFollowUpQuestion: false,
  }

  handleFollowUpResponse = response => {
    if (response === 'yes') {
      // To-do: refactor common component for Yes button dynamic behavior
      Object.assign(document.createElement('a'), { target: '_blank', href: 'https://apps.shopify.com/plug-in-seo#modal-show=ReviewListingModal'}).click()
    }

    this.setState({ showFollowUpQuestion: false })
  }

  renderFollowUpQuestion() {
    if (!this.state.showFollowUpQuestion) return null

    return (
      <FeedbackForm
        question="Great! Do you have a minute to leave us a review?"
        buttonTextYes="Sure, I have a minute"
        buttonTextNo="No, thanks"
        onAnswer={this.handleFollowUpResponse}
      />
    )
  }

  render() {
    return (
      <div className="satisfactionSurvey">
        <FeedbackForm
          question={`Did you get your ${this.props.featureType} set up successfully?`}
          helpLink={this.props.href}
          buttonTextYes="Yes, I did"
          buttonTextNo="No, I need help"
          repeating={!this.props.featureKey}
          storeKey={`support_${this.props.featureKey}`}
          onMount={() => AnalyticsUtils.supportOfferViewed(this.props.featureType)}
          onAnswer={answer => {
              AnalyticsUtils.supportOfferAnswered({
                email: this.context.currentUser.email,
                answer
              })
              if (answer === 'yes') this.setState({ showFollowUpQuestion: true })
            }
          }
        />
        {this.renderFollowUpQuestion()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/plus/SupportForm.js